// extracted by mini-css-extract-plugin
export var option = "_af-0";
export var optionCard = "_af-f";
export var optionContent = "_af-g";
export var optionIcon = "_af-i";
export var optionIconBox = "_af-h";
export var optionLabel = "_af-j";
export var optionPill = "_af-m";
export var optionPillBadge = "_af-p";
export var optionPillIcon = "_af-n";
export var optionPillLabel = "_af-o";
export var optionRadio = "_af-k";
export var optionRadioInner = "_af-l";
export var optionReveal = "_af-2";
export var optionRevealDelay0 = "_af-3";
export var optionRevealDelay1 = "_af-4";
export var optionRevealDelay10 = "_af-d";
export var optionRevealDelay11 = "_af-e";
export var optionRevealDelay2 = "_af-5";
export var optionRevealDelay3 = "_af-6";
export var optionRevealDelay4 = "_af-7";
export var optionRevealDelay5 = "_af-8";
export var optionRevealDelay6 = "_af-9";
export var optionRevealDelay7 = "_af-a";
export var optionRevealDelay8 = "_af-b";
export var optionRevealDelay9 = "_af-c";
export var optionSelected = "_af-1";